import { useEffect, useState, useCallback, useRef } from 'react';
import { useChainManager } from '../chain/hooks/useChainManager';
import { GroupInfo } from '../chain/interfaces/ChainAdapter';

export default function useGroupInfo(
  groupId: number | undefined | null,
  lixiBagAddress: string,
  groupOptions?: {
    blockhashHash?: string | null;
    buyer?: string | null;
  },
) {
  const [groupInfo, setGroupInfo] = useState<GroupInfo | undefined>();
  const [error, setError] = useState<Error | boolean>(false);
  const chainManager = useChainManager();
  const isFetching = useRef(false);

  const fetchGroupInfo = useCallback(async () => {
    if (
      (!groupId && !groupOptions?.blockhashHash) ||
      groupInfo ||
      isFetching.current
    ) {
      return;
    }

    isFetching.current = true;
    try {
      const fetchedGroupInfo = await chainManager.getGroupInfo({
        ...(groupId ? { groupId: groupId.toString() } : {}),
        ...(groupOptions?.blockhashHash
          ? { blockhashHash: groupOptions.blockhashHash }
          : {}),
        ...(groupOptions?.buyer ? { buyer: groupOptions.buyer } : {}),
      });
      setGroupInfo(fetchedGroupInfo || undefined);
    } catch (error) {
      console.log(error);
      setError(error as Error);
    } finally {
      isFetching.current = false;
    }
  }, [
    chainManager,
    groupId,
    groupInfo,
    groupOptions?.blockhashHash,
    groupOptions?.buyer,
  ]);

  useEffect(() => {
    fetchGroupInfo();
  }, [fetchGroupInfo]);

  return {
    groupInfo,
    error,
  };
}
